// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-data-model{position:relative}.no-data-model .no-data-box{text-align:center;margin:0 auto;margin-top:40px}.no-data-model .no-data-box .text{padding-top:10px;color:#666}", ""]);
// Exports
module.exports = exports;
